import type { RouteObject } from 'react-router-dom';
import { LoginPage } from '../pages/LoginPage';
import { SignupPage } from '../pages/SignupPage';
import { TenantSelectPage } from '../pages/TenantSelectPage';
import { VerifyEmailPage } from '../pages/VerifyEmailPage';
import { SegmentationPage } from '../pages/SegmentationPage';
import { VerifyPhonePage } from '../pages/VerifyPhonePage';

/**
 * PUBLIC routes: they go at the router's first level, outside `AppLayout`,
 * because there is no session yet. Views 1 (login), 2 (signup) and 3 (tenant
 * selector).
 *
 * All three mount on `CenteredCardLayout`, not on `AppShell` — the §5.5
 * contract says so explicitly.
 *
 * **They are the only ones that are NOT lazy-loaded**, unlike `AppLayout`'s 32
 * (see the note in `router.tsx`): one of these three is always the session's
 * first screen, so deferring them would add a network round trip at exactly the
 * moment it shows — and the three together are small, with no tables and no
 * editors.
 */
export const authRoutes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  { path: '/signup', element: <SignupPage /> },
  { path: '/tenants', element: <TenantSelectPage /> },
  // Reached straight after sign-up, which now leaves a session — so it is a
  // public route only in the sense that it renders outside `AppShell`; its
  // endpoints are behind `SessionGuard`.
  { path: '/verify-email', element: <VerifyEmailPage /> },
  // Same shape, and the step after it: the address code hands over to this one.
  { path: '/verify-phone', element: <VerifyPhonePage /> },
  // Screen 4. It renders outside `AppShell` for the same reason the two codes
  // do — it is still the entry sequence, not the product — and its endpoint is
  // behind `SessionGuard` like theirs.
  { path: '/segment', element: <SegmentationPage /> },
];
